module.exports = __webpack_public_path__ + "static/media/pexels-photo-1660030.ca318ae3.jpg";